import { render, staticRenderFns } from "./InfoNotification.vue?vue&type=template&id=4a24d1a4&scoped=true&"
import script from "./InfoNotification.vue?vue&type=script&lang=js&"
export * from "./InfoNotification.vue?vue&type=script&lang=js&"
import style0 from "./InfoNotification.vue?vue&type=style&index=0&id=4a24d1a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a24d1a4",
  null
  
)

export default component.exports